import type { ICalendarFieldIconProps } from './helpers';

export const CalendarFieldIcon = ({ variant = 'default', ...rest }: ICalendarFieldIconProps) => {
	if (variant === 'bvn')
		return (
			<svg
				width='16'
				height='16'
				viewBox='0 0 16 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M5.33301 1.33398V3.33398'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M10.667 1.33398V3.33398'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M2.33301 6.06055H13.6663'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M14 5.66732V11.334C14 13.334 13 14.6673 10.6667 14.6673H5.33333C3 14.6673 2 13.334 2 11.334V5.66732C2 3.66732 3 2.33398 5.33333 2.33398H10.6667C13 2.33398 14 3.66732 14 5.66732Z'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M7.99666 9.13411H8.00265'
					stroke='currentColor'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M5.52987 9.13411H5.53585'
					stroke='currentColor'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M5.52987 11.1341H5.53585'
					stroke='currentColor'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		);

	return (
		<svg
			width='12'
			height='12'
			viewBox='0 0 12 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M4 2.875C3.795 2.875 3.625 2.705 3.625 2.5V1C3.625 0.795 3.795 0.625 4 0.625C4.205 0.625 4.375 0.795 4.375 1V2.5C4.375 2.705 4.205 2.875 4 2.875Z'
				fill='#566F83'
			/>
			<path
				d='M8 2.875C7.795 2.875 7.625 2.705 7.625 2.5V1C7.625 0.795 7.795 0.625 8 0.625C8.205 0.625 8.375 0.795 8.375 1V2.5C8.375 2.705 8.205 2.875 8 2.875Z'
				fill='#566F83'
			/>
			<path
				d='M4.25 7.24918C4.185 7.24918 4.12 7.23419 4.06 7.20919C3.995 7.18419 3.945 7.14917 3.895 7.10417C3.805 7.00917 3.75 6.88418 3.75 6.74918C3.75 6.68418 3.765 6.61918 3.79 6.55918C3.815 6.49918 3.85 6.44418 3.895 6.39418C3.945 6.34918 3.995 6.31417 4.06 6.28917C4.24 6.21417 4.465 6.25418 4.605 6.39418C4.695 6.48918 4.75 6.61918 4.75 6.74918C4.75 6.77918 4.745 6.81419 4.74 6.84919C4.735 6.87919 4.725 6.90918 4.71 6.93918C4.7 6.96918 4.685 6.99918 4.665 7.02918C4.65 7.05418 4.625 7.07917 4.605 7.10417C4.51 7.19417 4.38 7.24918 4.25 7.24918Z'
				fill='#566F83'
			/>
			<path
				d='M6 7.24945C5.935 7.24945 5.87 7.23446 5.81 7.20946C5.745 7.18446 5.695 7.14944 5.645 7.10444C5.555 7.00944 5.5 6.88445 5.5 6.74945C5.5 6.68445 5.515 6.61945 5.54 6.55945C5.565 6.49945 5.6 6.44445 5.645 6.39445C5.695 6.34945 5.745 6.31444 5.81 6.28944C5.99 6.20944 6.215 6.25445 6.355 6.39445C6.445 6.48945 6.5 6.61945 6.5 6.74945C6.5 6.77945 6.495 6.81445 6.49 6.84945C6.485 6.87945 6.475 6.90945 6.46 6.93945C6.45 6.96945 6.435 6.99945 6.415 7.02945C6.4 7.05445 6.375 7.07944 6.355 7.10444C6.26 7.19444 6.13 7.24945 6 7.24945Z'
				fill='#566F83'
			/>
			<path
				d='M7.75 7.24945C7.685 7.24945 7.62 7.23446 7.56 7.20946C7.495 7.18446 7.445 7.14944 7.395 7.10444C7.375 7.07944 7.355 7.05445 7.335 7.02945C7.315 6.99945 7.3 6.96945 7.29 6.93945C7.275 6.90945 7.265 6.87945 7.26 6.84945C7.255 6.81445 7.25 6.77945 7.25 6.74945C7.25 6.61945 7.305 6.48945 7.395 6.39445C7.445 6.34945 7.495 6.31444 7.56 6.28944C7.745 6.20944 7.965 6.25445 8.105 6.39445C8.195 6.48945 8.25 6.61945 8.25 6.74945C8.25 6.77945 8.245 6.81445 8.24 6.84945C8.235 6.87945 8.225 6.90945 8.21 6.93945C8.2 6.96945 8.185 6.99945 8.165 7.02945C8.15 7.05445 8.125 7.07944 8.105 7.10444C8.01 7.19444 7.88 7.24945 7.75 7.24945Z'
				fill='#566F83'
			/>
			<path
				d='M4.25 8.99961C4.185 8.99961 4.12 8.98461 4.06 8.95961C4 8.93461 3.945 8.8996 3.895 8.8546C3.805 8.7596 3.75 8.62961 3.75 8.49961C3.75 8.43461 3.765 8.3696 3.79 8.3096C3.815 8.2446 3.85 8.18961 3.895 8.14461C4.08 7.95961 4.42 7.95961 4.605 8.14461C4.695 8.23961 4.75 8.36961 4.75 8.49961C4.75 8.62961 4.695 8.7596 4.605 8.8546C4.51 8.9446 4.38 8.99961 4.25 8.99961Z'
				fill='#566F83'
			/>
			<path
				d='M6 8.99961C5.87 8.99961 5.74 8.9446 5.645 8.8546C5.555 8.7596 5.5 8.62961 5.5 8.49961C5.5 8.43461 5.515 8.3696 5.54 8.3096C5.565 8.2446 5.6 8.18961 5.645 8.14461C5.83 7.95961 6.17 7.95961 6.355 8.14461C6.4 8.18961 6.435 8.2446 6.46 8.3096C6.485 8.3696 6.5 8.43461 6.5 8.49961C6.5 8.62961 6.445 8.7596 6.355 8.8546C6.26 8.9446 6.13 8.99961 6 8.99961Z'
				fill='#566F83'
			/>
			<path
				d='M7.75 9.00044C7.62 9.00044 7.49 8.94544 7.395 8.85544C7.35 8.81044 7.315 8.75545 7.29 8.69045C7.265 8.63045 7.25 8.56544 7.25 8.50044C7.25 8.43544 7.265 8.37044 7.29 8.31044C7.315 8.24544 7.35 8.19045 7.395 8.14545C7.51 8.03045 7.685 7.97544 7.845 8.01044C7.88 8.01544 7.91 8.02544 7.94 8.04044C7.97 8.05044 8 8.06545 8.03 8.08545C8.055 8.10045 8.08 8.12545 8.105 8.14545C8.195 8.24045 8.25 8.37044 8.25 8.50044C8.25 8.63044 8.195 8.76044 8.105 8.85544C8.01 8.94544 7.88 9.00044 7.75 9.00044Z'
				fill='#566F83'
			/>
			<path
				d='M10.25 4.91992H1.75C1.545 4.91992 1.375 4.74992 1.375 4.54492C1.375 4.33992 1.545 4.16992 1.75 4.16992H10.25C10.455 4.16992 10.625 4.33992 10.625 4.54492C10.625 4.74992 10.455 4.91992 10.25 4.91992Z'
				fill='#566F83'
			/>
			<path
				d='M8 11.375H4C2.175 11.375 1.125 10.325 1.125 8.5V4.25C1.125 2.425 2.175 1.375 4 1.375H8C9.825 1.375 10.875 2.425 10.875 4.25V8.5C10.875 10.325 9.825 11.375 8 11.375ZM4 2.125C2.57 2.125 1.875 2.82 1.875 4.25V8.5C1.875 9.93 2.57 10.625 4 10.625H8C9.43 10.625 10.125 9.93 10.125 8.5V4.25C10.125 2.82 9.43 2.125 8 2.125H4Z'
				fill='#566F83'
			/>
		</svg>
	);
};
